module.exports = "https://de18y2hs3hlxs.cloudfront.net/04bbf00c-82ab-4e06-8439-4302b170a242/images/notepad.png?75405c954d83b33e90b18b75fbe7ed89";